export const XIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 2.66666C8.63616 2.66666 2.66663 8.6362 2.66663 16C2.66663 23.3638 8.63616 29.3333 16 29.3333C23.3637 29.3333 29.3333 23.3638 29.3333 16C29.3333 8.6362 23.3637 2.66666 16 2.66666Z"
        fill="black"
      />
      <g clipPath="url(#clip0_1138_43715)">
        <path
          d="M20.1628 9.49997H22.3682L17.5502 15.0066L23.2182 22.5H18.7802L15.3042 17.9553L11.3268 22.5H9.12018L14.2735 16.61L8.83618 9.49997H13.3868L16.5288 13.654L20.1628 9.49997ZM19.3888 21.18H20.6108L12.7228 10.7506H11.4115L19.3888 21.18Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1138_43715">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(8.00012 7.99997)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
